// extracted by mini-css-extract-plugin
export default {"reportIcon":"reportIcon__ntcOsZjarwlZ"};